import Icon from '../components/Icon.vue'

Icon.register({
  'chevron-circle-right': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M256 8c137 0 248 111 248 248s-111 248-248 248-248-111-248-248 111-248 248-248zM369.9 239l-135.5-135.5c-9.4-9.4-24.6-9.4-33.9 0l-17 17c-9.4 9.4-9.4 24.6 0 33.9l101.6 101.6-101.6 101.6c-9.4 9.4-9.4 24.6 0 33.9l17 17c9.4 9.4 24.6 9.4 33.9 0l135.5-135.5c9.4-9.4 9.4-24.6 0-34z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/chevron-circle-right.js
// module id = 1190
// module chunks = 0